@use "styles/mixins/_fonts.scss" as fonts;

.footer {
  display: flex;
}

.has-footer {
  margin-top: var(--size-spacing-xs);
}

.error {
  flex-grow: 1;
  color: var(--color-text-error);

  &-content {
    @include fonts.body-accent-xs;

    display: flex;
    align-items: center;
    overflow-wrap: anywhere;

    &-icon {
      width: var(--typography-body-font-size);
      height: var(--typography-body-font-size);
      margin-right: var(--size-spacing-xs);
      flex-shrink: 0;
    }
  }
}
